export default __webpack_public_path__ + "static/media/flex_reviro.14fe7b77.svg";